// Opening the app from a push notification (HARDEN-pwa). The service worker opens
// `/c/{slug}#inbox` in a new window, or focuses an open one and posts `companyos:open` with that
// path; either way the company's Inbox page opens (INBOX-PAGE-MAIN: the page is the Inbox; the
// hash only says "the inbox", so a reload does not reopen it).
import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

/** The Inbox page for the company a path is in (`/c/{slug}/…`), or null outside a company. */
export function inboxPathFor(pathname: string): string | null {
  const m = /^\/c\/([^/]+)/.exec(pathname);
  return m ? `/c/${m[1]}/inbox` : null;
}

export function PushOpen() {
  const router = useRouter();
  useEffect(() => {
    if (window.location.hash === "#inbox") {
      const to = inboxPathFor(window.location.pathname);
      window.history.replaceState(
        window.history.state,
        "",
        window.location.pathname + window.location.search,
      );
      if (to) void router.navigate({ to: to as never });
    }
    const sw = typeof navigator !== "undefined" ? navigator.serviceWorker : undefined;
    if (!sw) return;
    const onMessage = (event: MessageEvent) => {
      const data = event.data as { type?: string; url?: string } | null;
      if (data?.type !== "companyos:open" || typeof data.url !== "string") return;
      const url = new URL(data.url, window.location.origin);
      if (url.origin !== window.location.origin) return;
      const inbox = url.hash === "#inbox" ? inboxPathFor(url.pathname) : null;
      void router.navigate({ to: (inbox ?? url.pathname) as never });
    };
    sw.addEventListener("message", onMessage);
    return () => sw.removeEventListener("message", onMessage);
  }, [router]);
  return null;
}
